import React from "react";
import { CheckCircle2 } from "lucide-react";

const benefits = [
  "Ausgebildete Fachkräfte", // Trained Professionals
  "Pünktlicher Service",    // On-Time Service
  "Transparente Preise",    // Affordable Pricing (më mirë se thjesht "günstig")
  "Qualität & Präzision",    // Quality & Precision (në vend të produkteve higjienike)
  "Kundenzufriedenheit"     // Satisfaction Guaranteed
];

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-white overflow-hidden" id="why-choose-us"> {/* Shtova ID */}
      <div className="max-w-[1600px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* IMAGE SIDE */}
          <div className="relative order-2 lg:order-1">
            {/* Decorative Red Background Box */}
            <div 
              className="absolute -inset-4 rounded-[2.5rem] opacity-20 transform -rotate-2"
              style={{ backgroundColor: "#ff4a4a" }}
            ></div>
            
            {/* Main Image */}
            <div className="relative rounded-[2.5rem] overflow-hidden shadow-2xl">
              <img 
                src="https://plus.unsplash.com/premium_photo-1663047170515-66632d2a374d?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
                alt="Sanitär- und Heizungstechniker bei der Arbeit" // Teksti ALT i përshtatur
                className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>

          {/* TEXT SIDE */}
          <div className="order-1 lg:order-2">
            <p className="font-bold tracking-widest text-xs uppercase mb-4" style={{ color: "#ff4a4a" }}>
              WARUM SANISTYLE?
            </p>
            {/* 👇 TITULLI KRYESOR I NDRYSHUAR */}
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Wir setzen Standards für <br /> moderne Haustechnik.
            </h2>
            {/* 👇 PARAGRAFI I NDRYSHUAR */}
            <p className="text-gray-500 text-lg mb-10 leading-relaxed">
              Wir installieren nicht nur; wir kümmern uns um Ihr Zuhause. Erleben Sie den Unterschied eines Services, der auf Zuverlässigkeit, Qualität und Vertrauen basiert.
            </p>

            {/* List of Points (me tekst të ri gjermanisht) */}
            <div className="space-y-5">
              {benefits.map((item, index) => (
                <div key={index} className="flex items-center gap-4 group">
                  {/* Icon Box */}
                  <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <CheckCircle2 className="w-6 h-6" style={{ color: "#ff4a4a" }} />
                  </div>
                  
                  {/* Text */}
                  <span className="text-xl font-medium text-gray-800 group-hover:text-gray-900 transition-colors">
                    {item}
                  </span>
                </div>
              ))}
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;